/**
 * @generated SignedSource<<7a4be59573c4ebd4dd965606eac10d47>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type areaDesignerMutation$variables = {
  id: string;
};
export type areaDesignerMutation$data = {
  readonly deletePrintAreaTemplate: {
    readonly printAreaTemplate: {
      readonly name: string;
    } | null;
  } | null;
};
export type areaDesignerMutation = {
  response: areaDesignerMutation$data;
  variables: areaDesignerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "areaDesignerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PrintAreaTemplateOutput",
        "kind": "LinkedField",
        "name": "deletePrintAreaTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintAreaTemplate",
            "kind": "LinkedField",
            "name": "printAreaTemplate",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "areaDesignerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PrintAreaTemplateOutput",
        "kind": "LinkedField",
        "name": "deletePrintAreaTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintAreaTemplate",
            "kind": "LinkedField",
            "name": "printAreaTemplate",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16012af2e925b527f57f2487f48274a2",
    "id": null,
    "metadata": {},
    "name": "areaDesignerMutation",
    "operationKind": "mutation",
    "text": "mutation areaDesignerMutation(\n  $id: ID!\n) {\n  deletePrintAreaTemplate(id: $id) {\n    printAreaTemplate {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0be72e3efa04ed0a0e907922aaf79889";

export default node;
